<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ContactList" });
import * as API from "../../services/api.js";
import { CONTACT_STORE, CONTACT_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable, derived } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $CONTACT_HASH;
const syncFromGlobalStore = (data) => {
    const CONTACTS = get(STORE).map((contact) => {
        const KEY = contact._.key;
        if (!(KEY in data)) {
            return contact;
        }
        return data[KEY];
    });
    STORE.set(CONTACTS);
};
const setStore = (contacts) => {
    STORE.set(contacts);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterContacts({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onContactHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $CONTACT_HASH;
    isLoading = true;
    void API.filterContacts({ ...parameters }).then(setStore);
};
$: onContactHashChange($CONTACT_HASH);
onMount(() => {
    unsubscribe = CONTACT_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
export const COUNT = derived(STORE, ($STORE) => $STORE.length);
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot contacts = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}